<template>
  <Label :variant="variant" :size="mappedSize" :show-dot="showDot">
    {{ label || $t(`proposals.statuses.${status}`) }}
  </Label>
</template>

<script>
  import { defineComponent, computed } from 'vue';
  import Label from '@/components/partials/Label.vue';

  const STATUS_VARIANTS = {
    draft: 'default',
    sending: 'info',
    sent: 'info',
    viewed: 'warning',
    accepted: 'success',
    rejected: 'danger',
    superseded: 'default',
    withdrawn: 'default',
  };

  export default defineComponent({
    name: 'ProposalStatusBadge',

    components: { Label },

    props: {
      status: {
        type: String,
        required: true,
        validator: (value) =>
          [
            'draft',
            'sending',
            'sent',
            'viewed',
            'accepted',
            'rejected',
            'superseded',
            'withdrawn',
          ].includes(value),
      },
      size: {
        type: String,
        default: 'default',
        validator: (value) => ['default', 'small', 'sm', 'xs'].includes(value),
      },
      showDot: {
        type: Boolean,
        default: true,
      },
      label: {
        type: String,
        default: null,
      },
    },

    setup(props) {
      const variant = computed(() => STATUS_VARIANTS[props.status] || 'default');

      const mappedSize = computed(() => (props.size === 'default' ? 'default' : 'sm'));

      return { variant, mappedSize };
    },
  });
</script>
